/**
 * Diamond Swimwear — Collection Page JavaScript
 * ────────────────────────────────────────────────
 * Modules:
 *  1. Sort — URL param update on change
 *  2. Filters — checkbox/price → URL param + apply
 *  3. Filter panel open/close (desktop sidebar + mobile bottom sheet)
 *  4. Infinite scroll / Load More
 */

(function () {
  'use strict';

  const section = document.querySelector('[data-collection-section]');
  if (!section) return;

  const grid       = document.querySelector('[data-product-grid]');
  const loadMore   = document.querySelector('[data-load-more]');
  const filterPanel= document.querySelector('[data-filter-panel]');
  const filterToggle = document.querySelector('[data-filter-toggle]');
  const filterClose  = document.querySelector('[data-filter-close]');
  const filterApply  = document.querySelector('[data-filter-apply]');
  const filterBackdrop = document.querySelector('[data-filter-backdrop]');
  const sortSelect = document.querySelector('[data-sort-select]');

  /* ── 1. Sort ─────────────────────────────────────── */
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location = url.toString();
    });
  }

  /* ── 2. Filters ──────────────────────────────────── */
  let filterTimeout;

  function buildFilterURL() {
    const url = new URL(window.location);

    /* Clear existing filter params */
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.') || key === 'page') {
        url.searchParams.delete(key);
      }
    }

    /* Re-add checked filters */
    document.querySelectorAll('[data-filter-checkbox]:checked').forEach(input => {
      url.searchParams.append(input.name, input.value);
    });

    /* Price range */
    document.querySelectorAll('[data-price-filter]').forEach(input => {
      if (input.value) url.searchParams.set(input.name, input.value);
    });

    return url;
  }

  function applyFilters() {
    window.location = buildFilterURL().toString();
  }

  /* Desktop: auto-apply on checkbox change */
  document.querySelectorAll('[data-filter-checkbox]').forEach(input => {
    input.addEventListener('change', () => {
      if (window.innerWidth >= 1024) {
        clearTimeout(filterTimeout);
        filterTimeout = setTimeout(applyFilters, 300);
      }
    });
  });

  /* Price inputs: debounced apply on desktop */
  document.querySelectorAll('[data-price-filter]').forEach(input => {
    input.addEventListener('change', () => {
      if (window.innerWidth >= 1024) {
        clearTimeout(filterTimeout);
        filterTimeout = setTimeout(applyFilters, 600);
      }
    });
  });

  /* Mobile: apply on button click */
  filterApply && filterApply.addEventListener('click', applyFilters);

  /* ── 3. Filter Panel ─────────────────────────────── */
  function openFilterPanel() {
    filterPanel && filterPanel.classList.add('is-open');
    filterToggle && filterToggle.setAttribute('aria-expanded', 'true');
    filterBackdrop && filterBackdrop.classList.add('is-visible');
    document.body.classList.add('drawer-open');
  }

  function closeFilterPanel() {
    filterPanel && filterPanel.classList.remove('is-open');
    filterToggle && filterToggle.setAttribute('aria-expanded', 'false');
    filterBackdrop && filterBackdrop.classList.remove('is-visible');
    document.body.classList.remove('drawer-open');
  }

  filterToggle && filterToggle.addEventListener('click', () => {
    const isOpen = filterPanel && filterPanel.classList.contains('is-open');
    isOpen ? closeFilterPanel() : openFilterPanel();
  });

  filterClose && filterClose.addEventListener('click', closeFilterPanel);
  filterBackdrop && filterBackdrop.addEventListener('click', closeFilterPanel);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && filterPanel && filterPanel.classList.contains('is-open')) {
      closeFilterPanel();
    }
  });

  /* ── 4. Load More / Infinite Scroll ──────────────── */
  if (loadMore && grid) {
    const loadBtn  = loadMore.querySelector('[data-load-more-btn]');
    const spinner  = loadMore.querySelector('.dw-spinner');
    let isLoading  = false;

    /* Explicitly hide spinner on init — CSS display:inline-block overrides [hidden] */
    if (spinner) spinner.style.display = 'none';

    function resetBtn() {
      isLoading = false;
      if (loadBtn) { loadBtn.disabled = false; loadBtn.querySelector('span:first-child').style.display = ''; }
      if (spinner) spinner.style.display = 'none';
    }

    async function loadNextPage() {
      if (isLoading) return;
      const nextUrl = loadMore.dataset.loadMoreUrl;
      if (!nextUrl) return;

      isLoading = true;
      if (loadBtn) { loadBtn.disabled = true; loadBtn.querySelector('span:first-child').style.display = 'none'; }
      if (spinner) spinner.style.display = 'inline-block';

      try {
        const res  = await fetch(nextUrl);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const html = await res.text();
        const doc  = new DOMParser().parseFromString(html, 'text/html');

        /* Extract new items */
        const newItems = doc.querySelectorAll('[data-grid-item]');
        newItems.forEach(item => {
          item.style.opacity = '0';
          item.style.transform = 'translateY(16px)';
          grid.appendChild(item);

          requestAnimationFrame(() => {
            item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
            item.style.opacity = '1';
            item.style.transform = 'translateY(0)';
          });
        });

        /* Update count */
        const newCount = doc.querySelector('[data-collection-count]');
        const countEl  = document.querySelector('[data-collection-count]');
        if (newCount && countEl) countEl.textContent = newCount.textContent;

        /* Update URL and next page link */
        const nextLoadMore = doc.querySelector('[data-load-more]');
        if (nextLoadMore && nextLoadMore.dataset.loadMoreUrl) {
          loadMore.dataset.loadMoreUrl = nextLoadMore.dataset.loadMoreUrl;
          resetBtn();
        } else {
          /* No more pages */
          loadMore.remove();
        }

        /* Update browser URL */
        try {
          const pageUrl = new URL(nextUrl);
          window.history.pushState({}, '', pageUrl.toString());
        } catch (_) {}

      } catch (err) {
        console.error('[DW Collection] Load more failed:', err);
        resetBtn();
      }
    }

    /* Button click only — no auto-trigger */
    loadBtn && loadBtn.addEventListener('click', loadNextPage);
  }

})();
